


























































































import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { IActivityLog } from "@/models/activity-log.entity";
import { Component, Prop, Ref } from "vue-property-decorator";
import ContextMenu from "../utility/ContextMenu.vue";
import TimeLineItemText from "../utility/TimeLineItemText.vue";
import TimelineCard from "../utility/TimelineItem.vue";
import TemplateDialog from "../template/TemplateDialog.vue";
import ActivityTimeLineItemDelete from "./ActivityTimeLineItemDelete.vue";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { ClearanceApprovalDataAccessLayer } from "@/store/modules/access-layers/clearance-approval.access-layer";
import { IClearanceApproval, ClearanceApproval } from "@/models/clearance-approval.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { RepairEstimateDataAccessLayer } from "@/store/modules/access-layers/repair-estimate.access-layer";
import { activityLogName } from "@/lib/utility/activityLogName";
import { $t } from "@/lib/utility/t";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { PartnerModule } from "@/store/modules/partner";
import { handleError } from "@/lib/utility/handleError";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";

@Component({
  components: {
    TimeLineItemText,
    TimelineCard,
    TemplateDialog,
    ActivityTimeLineItemDelete,
    ContextMenu
  }
})
export default class ActivityTimeLineHistoryStatus extends DarkModeHighlightMixin {
  @Prop({})
  activityLogEntry!: IActivityLog;

  @Ref("replyToInformationRequestDialog")
  replyToInformationRequestDialog!: TemplateDialog;

  entity: IClearanceApproval | IRepairEstimate | null = null;

  get history() {
    const targetAt = this.activityLogEntry.comment;

    if (this.entity?.history?.length) {
      const historyAt = this.entity.history.find(h => h.at === targetAt);

      return historyAt;
    }

    return null;
  }

  get name() {
    return activityLogName(this.activityLogEntry);
  }

  get text() {
    const history = this.history;

    if (!history) {
      return "";
    }

    const at = simpleDoubleDigitDate(history.at);
    const status = history.status;

    return this.$t("timeLine.ActivityTimeLineHistoryStatus.text", {
      at,
      status: '"' + $t(`enums.RequestStatusEnum.${status}`) + '"'
    });
  }

  get showReplyButton() {
    if (!this.history) return false;

    return this.history.status === RequestStatusEnum.REQUEST_MORE_DATA;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get to() {
    if (this.entity && this.entity?.seller?.email) {
      return [this.entity.seller.email];
    }
    return [];
  }

  get refs() {
    if (!this.entity) return [];

    return [
      {
        refId: this.activityLogEntry.source.refId,
        refType: this.activityLogEntry.source.refType
      }
    ];
  }

  get context() {
    if (!this.entity) return {};

    if (this.activityLogEntry.source.refType === BackendResourceEnum.REPAIR_ESTIMATE) {
      return { repairEstimate: this.entity };
    } else if (this.activityLogEntry.source.refType === BackendResourceEnum.CLEARANCE_APPROVAL) {
      return { clearanceApproval: this.entity };
    }

    return {};
  }

  async mounted() {
    this.entity = (await this.fetchEntity()) ?? null;
  }

  async fetchEntity() {
    const refType = this.activityLogEntry.source.refType;
    const refId = this.activityLogEntry.source.refId;
    const partnerId = this.activityLogEntry.partnerId;

    if (refType === BackendResourceEnum.CLEARANCE_APPROVAL) {
      return (
        ClearanceApprovalDataAccessLayer.get(refId) ??
        new ClearanceApproval({
          partnerId,
          id: refId
        }).fetch()
      );
    }
    if (refType === BackendResourceEnum.REPAIR_ESTIMATE) {
      return (
        RepairEstimateDataAccessLayer.get(refId) ??
        new RepairEstimate({
          partnerId,
          id: refId
        }).fetch()
      );
    }
  }

  openReplyDialog() {
    this.replyToInformationRequestDialog?.show();
  }

  async resetStateBackToRequested() {
    if (!this.entity) return;

    try {
      await this.entity.updatePartial({
        status: RequestStatusEnum.REQUESTED
      });
    } catch (e) {
      handleError(e);
    }
  }
}
